export const environment = {
    production: true,
    baseUrl: 'https://guideespresso-purpletree.menatcode.it/',
    assetsUrl: 'https://bfc-media-api.menatcode.it/index.php',
    apiUrl: 'https://bfc-media-api.menatcode.it/',
};
